import { config } from 'lib-shared-backend-config';
import { HTTPRequestMethod } from 'lib-shared-legacy-types';

import { ajaxSend, ApiBasePath } from 'api/api';

import type {
  FlowCallGetAllMusicResponseT,
  FlowCallMusicSplitPayloadT,
  FlowCallMusicSplitResponseT,
  FlowCallUploadFilePayloadT,
  FlowCallUploadFileResponseT,
} from '../../../holdMusic/components/types';

const base = '/v1/wait_music';

export function getAllMusic() {
  return ajaxSend<FlowCallGetAllMusicResponseT>({
    path: `${base}`,
  });
}

export function uploadFile(payload: FlowCallUploadFilePayloadT) {
  if (!payload) {
    console.error('upload - No valid payload given.');
    return Promise.reject();
  }

  if (payload.file === undefined) {
    console.error('upload file - No valid file in payload given.');
    return Promise.reject();
  }

  const data = new FormData();
  data.append('file', payload.file);

  return ajaxSend<FlowCallUploadFileResponseT>({
    path: `/private/attachment`,
    method: HTTPRequestMethod.Post,
    basePath: ApiBasePath.Files,
    headers: {
      contentType: 'multipart/form-data',
    },
    data,
  }).then(
    (response: FlowCallUploadFileResponseT): FlowCallUploadFileResponseT => {
      if (response.data?.relative_uri) {
        response.data.absolute_uri = `${config.url.files}${response.data.relative_uri}`;
        return response;
      }
      return response;
    },
  );
}

export function musicSplit(payload: FlowCallMusicSplitPayloadT) {
  return ajaxSend<FlowCallMusicSplitResponseT>({
    method: HTTPRequestMethod.Post,
    path: `${base}`,
    data: {
      name: payload.name,
      master_file_path: payload.masterFilePath,
    },
  });
}
